<template>
    <b-card-group>
        <b-card no-body>
            <div class="card-body">
                <div>
                    <b-form>
                        <b-row>
                            <b-col cols="1">
                              <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                                <font-awesome-icon icon="times" />
                                {{ $t('Сброс') }}
                              </b-button>
                            </b-col>
                            <filter-input cols="2" :label="$t('Название')" v-model="form.name"
                                          v-on:onBlur="search"></filter-input>
                            <filter-input cols="2" :label="$t('Раздел')" v-model="form.section"
                                          v-on:onBlur="search"></filter-input>
                            <filter-checkbox :label="$t('Действующие')" v-model="form.isActive"
                                             v-on:onChange="changeIsActive"></filter-checkbox>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </b-card>
    </b-card-group>
</template>

<script>
  import BaseFilter from "@/models/base.filter";

  export default {
    name: "filter-form",
    extends: BaseFilter,
    props: {
      isActive: [String, Boolean],
      name: String
    },
    methods: {
      changeIsActive() {
        this.form.isActive = !this.form.isActive;
        this.search();
      }
    },
    data() {
      return {
        form: {
          isActive: this.isActive == 'true' || false,
          name: this.name,
          section: this.section
        }
      };
    }
  };
</script>
